import { IconPencil, IconTrash } from "@tabler/icons-react";
import { useEliminarLinea } from "@/features/prorrateo/hooks/use-prorrateo-mutations";
import type { LineaProrrateo } from "@/features/prorrateo/types";
import { Badge, Group, IconAction, Td, Text, Tr } from "@/components/ui";

interface Props {
  linea: LineaProrrateo;
  disabled: boolean;
  solicitudId: string;
  onEdit: () => void;
}

/**
 * Fila en modo lectura · presentacional con un solo efecto: dispara
 * `useEliminarLinea` (sigue siendo el único punto donde una mutación
 * vive cerca del botón que la dispara). Si `disabled` (prorrateo
 * confirmado o solo lectura) las acciones se ocultan.
 */
export function LineaRowView({ linea, disabled, solicitudId, onEdit }: Props) {
  const eliminar = useEliminarLinea(solicitudId);
  const esManual = linea.tipo === "Manual";

  return (
    <Tr>
      <Td className="font-mono">{linea.numeroLinea}</Td>
      <Td>
        <Badge variant="light" color={esManual ? "azulProfundo" : "info"} uppercase={false}>
          {linea.tipo}
        </Badge>
      </Td>
      <Td>
        <Text size="xs" ff="mono">
          {linea.claveSat}
        </Text>
      </Td>
      <Td>
        <Text size="sm">{linea.descripcion}</Text>
      </Td>
      <Td>
        <Text size="sm">{linea.centroDeCostoCodigo}</Text>
      </Td>
      <Td>
        <Text size="sm">{linea.cuentaContableCodigo}</Text>
      </Td>
      <Td align="right">
        <Text size="sm" fw={500}>
          ${linea.importe.toFixed(2)}
        </Text>
      </Td>
      <Td>
        <Badge variant="outline" color="multiva" uppercase={false}>
          {linea.indicador}
        </Badge>
      </Td>
      <Td align="right">
        {!disabled && (
          <Group gap={4} justify="flex-end" wrap="nowrap">
            <IconAction label="Editar" variant="subtle" size="sm" onClick={onEdit}>
              <IconPencil size={14} stroke={1.7} />
            </IconAction>
            {esManual && (
              <IconAction label="Eliminar" variant="subtle" size="sm" iconColor="peligro-600" loading={eliminar.isPending} onClick={() => eliminar.mutate(linea.id)}>
                <IconTrash size={14} stroke={1.7} />
              </IconAction>
            )}
          </Group>
        )}
      </Td>
    </Tr>
  );
}
